import { Typography } from '@material-ui/core';
import { FC, MouseEventHandler } from 'react';

interface ErrorLinkProps {
  onClick: MouseEventHandler<HTMLDivElement>;
  title: string;
}

export const ErrorLink: FC<ErrorLinkProps> = ({
  onClick,
  title,
  ...otherProps
}) => (
  <Typography
    color="primary"
    component="div"
    role="link"
    tabIndex={0}
    style={{ cursor: 'pointer' }}
    onClick={onClick}
    {...otherProps}
  >
    {title}
  </Typography>
);
